<template>
  <div class="event-procedure">
    <event-detail-title :type="anchorMap.PROCEDURE_KEY"></event-detail-title>
    <div class="section-content">
      <markdown-beautiful :data="events_procedure_html"></markdown-beautiful>
    </div>
  </div>
</template>

<script>
import eventDetailTitle from './event-detail-title'
import markdownBeautiful from '@/components/markdown-beautiful'
import { anchorMap } from './utils'
import vueTypes from 'vue-types'

export default {
  data () {
    return {
      anchorMap
    }
  },
  props: {
    events_procedure_html: vueTypes.string.isRequired
  },
  components: {
    eventDetailTitle,
    markdownBeautiful
  }
}
</script>

<style lang="scss" scoped>
  .event-procedure {
    .section-content {
      line-height: 32px;
      color: #4A4A4A;
      margin-bottom: 30px
    }
  }

</style>
